export default {
  init() {
    // JavaScript to be fired on all pages

    ////////////////////////////////////////////////////////////////////////////////////////////
    // Padding for footer
    ////////////////////////////////////////////////////////////////////////////////////////////
    // function getFooterHeight() {
    //   var footerHeight = $('.content-info').outerHeight();
    //   $('body').css('padding-bottom', footerHeight);
    // }

    // getFooterHeight();

    // $(window).on('resize', function(){
    //   getFooterHeight();
    // });

    ////////////////////////////////////////////////////////////////////////////////////////////
    // Cookie consent
    ////////////////////////////////////////////////////////////////////////////////////////////
    $(document).on('click', '.cookie-consent button', function() {
      $('.cookie-consent').fadeOut();
      $.ajax({
        url: '/app/themes/zeus-digital/resources/ajax/setcookie.php',
        cache: false,
        success:function() {
          console.log('cookie set');
        },
      });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Toggle Navigation
    $('.noscroll').on('touchmove', function(e) {
      e.preventDefault();
    });

    $('.toggle-nav, .main-navigation a').click(function(e){
      e.preventDefault;
      $('body').toggleClass('open-nav');
    });

    // Add class to body when scrolled past the top bar
    var scrolled = function() {

      var height = jQuery('header').outerHeight();
      //var height = 20;

      if (jQuery(window).scrollTop() > height) {
        jQuery('body').addClass('scrolled');
      } else {
        jQuery('body').removeClass('scrolled');
      }
    };

    jQuery(window).scroll(function(){
      scrolled();
    });

    // ScrollTo
    $('a[href*="#"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

        if (target.length) {
          event.preventDefault()
          $('html,body').animate({
            scrollTop: target.offset().top,
          }, 1000);
        }
      }
    });

    ////////////////////////////////////////////////////////////////////////////////////////////
    // Detect request animation frame (For triggering on scroll)
    ////////////////////////////////////////////////////////////////////////////////////////////
    var scroll = window.requestAnimationFrame ||
    // IE Fallback
    function(callback){ window.setTimeout(callback, 1000/60)};
    var elementsToShow = document.querySelectorAll('.reveal-block');

    function loop() {
      elementsToShow.forEach(function (element) {
        if (isElementInViewport(element)) {
          element.classList.add('revealed');
        } else  {
          element.classList.remove('revealed');
        }
      });

      scroll(loop);
    }

    // Call the loop for the first time
    loop();

    function isElementInViewport(el) {
      // special bonus for those using jQuery
      if (typeof jQuery === 'function' && el instanceof jQuery) {
        el = el[0];
      }
      var rect = el.getBoundingClientRect();
      var middle = (rect.top + rect.bottom) / 2;
      return (middle <= $(window).height() );
    }

    ////////////////////////////////////////////////////////////////////////////////////////////
    // Add loaded class to body when js is loaded
    ////////////////////////////////////////////////////////////////////////////////////////////

    // Prepare the body tag by adding a "js-paused" class
    $(function() {
      $('.loading-overlay').fadeOut(800),
      $('body').addClass('js-loaded')
    });

    // Listen for when everything has loaded
    window.addEventListener('load', showPage, false);

    function showPage() {
      // Remove the "js-paused" class
      document.body.classList.remove('js-loading');
      document.body.classList.add('js-loaded');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js